import { pushNewDataPoint } from "../../script/din/dataBroker";
export async function newDataPointPushUp(mesurmentList) {
    const requestList = [];
    // env.group.merurmentList.forEach((mesDes) => {
    mesurmentList.forEach((mesDes) => {
        const dbId = mesDes.mes.dbUid;
        const targetDataPointDescripiton = mesDes.mes.static.targetDataPoints.filter((val) => val.temp === mesDes.data.meta.targetTemp); //addHum
        if (targetDataPointDescripiton.length === 0) {
            // to do, multiple find
            console.error("Imposible situation happend in sending mesurment");
            return;
        }
        targetDataPointDescripiton.forEach((trgDt) => {
            const newDataPointrequest = {
                measurement_dbUid: dbId,
                dataPointSequenceId: trgDt.sequenceId,
                measurementStartTS: mesDes.data.meta.mesurmentStartTS,
                measurementEndTS: mesDes.data.meta.mesurmentEndTS,
                targetTemp: mesDes.data.meta.targetTemp,
                data: mesDes.data.dataPoints.map((dt) => {
                    return {
                        TS: dt.TS,
                        sequenceId: dt.sequenceId,
                        probeVal: dt.probeValue,
                        etalonVal: dt.etalonValue,
                    };
                }),
            };
            requestList.push(pushNewDataPoint(newDataPointrequest));
        });
    });
    const ret = await Promise.all(requestList);
    const allReqSucesfull = ret.reduce((acc, val) => {
        return acc && Boolean(val);
    }, true);
    return allReqSucesfull;
}
